import React from 'react';
import { ShieldAlert, ShieldCheck, KeyRound } from 'lucide-react';
import ToggleSwitch from '../../../components/Forms/Input/ToggleSwitch';

interface Props {
  form: {
    locked: boolean;
    status: boolean;
    twoFactorEnabled: boolean;
  };
  onChange: (field: string, value: any) => void;
}

const UserStatusToggles: React.FC<Props> = ({ form, onChange }) => {
  // Un usuario bloqueado no puede quedar activo al mismo tiempo: al bloquear
  // se desactiva automáticamente; al desbloquear, el estado activo se deja a
  // criterio del administrador.
  const handleLockedChange = () => {
    const nextLocked = !form.locked;
    onChange('locked', nextLocked);
    if (nextLocked) onChange('status', false);
  };

  const rows = [
    {
      field: 'status',
      label: 'Usuario activo',
      description: 'Puede iniciar sesión y operar en el sistema.',
      icon: ShieldCheck,
      checked: form.status,
      onChange: () => onChange('status', !form.status),
      disabled: form.locked,
    },
    {
      field: 'locked',
      label: 'Bloqueado',
      description: 'Impide el inicio de sesión y desactiva al usuario.',
      icon: ShieldAlert,
      checked: form.locked,
      onChange: handleLockedChange,
      disabled: false,
    },
    {
      field: 'twoFactorEnabled',
      label: 'Autenticación de dos factores',
      description: 'Exige un código adicional al iniciar sesión.',
      icon: KeyRound,
      checked: form.twoFactorEnabled,
      onChange: () => onChange('twoFactorEnabled', !form.twoFactorEnabled),
      disabled: false,
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {rows.map((row) => {
        const Icon = row.icon;
        return (
          <div
            key={row.field}
            className={`flex flex-col gap-2 rounded-xl border border-stroke bg-gray-2/40 p-4 dark:border-strokedark dark:bg-meta-4/10 ${
              row.disabled ? 'opacity-70' : ''
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2">
                <Icon className="h-4 w-4 shrink-0 text-primary" />
                <span className="text-sm font-medium text-black dark:text-white">
                  {row.label}
                </span>
              </div>
              <ToggleSwitch
                label=""
                name={row.field}
                checked={row.checked}
                onChange={row.onChange}
                disabled={row.disabled}
              />
            </div>
            <p className="text-xs text-bodydark2">{row.description}</p>
          </div>
        );
      })}
    </div>
  );
};

export default UserStatusToggles;
